import FinalizeClassAttendanceDataIcon from '@material-ui/icons/ViewList';

import FinalizeClassAttendanceDataList from './FinalizeClassAttendanceDataList';

export default {
  list: FinalizeClassAttendanceDataList,
  icon: FinalizeClassAttendanceDataIcon,
};
